import { type DrawDefinition } from '@clubspark-node/clubspark-tennis-types';
import { drawDefinitionConstants } from 'tods-competition-factory';

const { MAIN, QUALIFYING } = drawDefinitionConstants;

export const supportedDrawTypes = {
  COMPASS: drawDefinitionConstants.COMPASS,
  SINGLE_ELIMINATION: drawDefinitionConstants.SINGLE_ELIMINATION,
  FMLC: drawDefinitionConstants.FIRST_MATCH_LOSER_CONSOLATION,
  CURTIS: drawDefinitionConstants.CURTIS,
  FICSF: drawDefinitionConstants.FICSF,
  VOLUNTARY_CONSOLATION: drawDefinitionConstants.VOLUNTARY_CONSOLATION,
  FICQF: drawDefinitionConstants.FICQF,
  FICR16: drawDefinitionConstants.FICR16,
  MFIC: drawDefinitionConstants.MFIC,
  FEED_IN_CHAMPIONSHIP: drawDefinitionConstants.FEED_IN_CHAMPIONSHIP,
  ROUND_ROBIN: drawDefinitionConstants.ROUND_ROBIN,
  ROUND_ROBIN_WITH_PLAYOFF: drawDefinitionConstants.ROUND_ROBIN_WITH_PLAYOFF,
  AD_HOC: drawDefinitionConstants.AD_HOC,
};

export const ROUND_ROBIN_GROUP_SIZE_LIMIT = 32;

export const getQualifyingDrawsStatus = (drawDefinition: DrawDefinition) => {
  const mainDraw = drawDefinition?.structures?.find((s) => s.stage === MAIN);
  const isMainRoundRobin = mainDraw?.structureType === 'CONTAINER';
  const mainMatchUpsCount = mainDraw?.matchUps?.length;
  const qualifyingMatchUpsCount = drawDefinition?.structures?.find((s) => s.stage === QUALIFYING)?.matchUps?.length;

  const isAddMainDrawToQualifying = mainMatchUpsCount === 0 && qualifyingMatchUpsCount > 0;
  const isAddQualifyingDrawToMain = (mainMatchUpsCount > 0 || isMainRoundRobin) && qualifyingMatchUpsCount === 0;

  return {
    isAddMainDrawToQualifying,
    isAddQualifyingDrawToMain,
  };
};
